import { Radio } from '@mui/material'
import { BaseScatola, BaseGridLayout } from '@lucan/base-ui'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { FRONTOFFICE_VERBALE_DATI_PERSONALI } from 'configuration/frontoffice'
import ConfigManager from 'components/config/ConfigManager'
import ListaLabelValoreSeparata from 'components/ui/ListaLabelValoreSeparata'
import Sezione from 'components/ui/Sezione'
import Testo from 'components/ui/Testo'
import Titoletto from 'components/ui/Titoletto'

const CFG = FRONTOFFICE_VERBALE_DATI_PERSONALI

export default function DatiPersonali(props) {
  const { datiPersonali, datiPersonaliCf, setDatiPersonaliCf } = props
  const {
    codiceFiscale,
    extra: { dataDiNascita, nome, cognome }
  } = datiPersonali

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_FRONTOFFICE_VERBALE_DATI_PERSONALI]}
      render={({ val, txt }) =>
        <>
          <Titoletto>{txt(CFG.TITOLO)}</Titoletto>
          <Testo sx={{ mb: 3 }}>{txt(CFG.SOTTOTITOLO)}</Testo>

          <Sezione>
            <BaseScatola outlined>
              <BaseGridLayout alignCenter justifySpaceBetween>
                <Titoletto sx={{ ml: 0, mb: 2 }} variant='h4'>{nome} {cognome}</Titoletto>
                <Radio
                  checked={codiceFiscale === datiPersonaliCf}
                  value={codiceFiscale}
                  onChange={e => setDatiPersonaliCf(e.target.value)}
                />
              </BaseGridLayout>

              <ListaLabelValoreSeparata
                lista={[
                  { label: val(CFG.CODICE_FISCALE), valore: codiceFiscale },
                  { label: val(CFG.DATA_NASCITA), valore: dataDiNascita },
                ]}
              />
            </BaseScatola>
          </Sezione>
        </>
      }
    />
  )
}